import { render, staticRenderFns } from "./CultivationNavigation.vue?vue&type=template&id=5dc395fb&scoped=true&"
import script from "./CultivationNavigation.vue?vue&type=script&lang=js&"
export * from "./CultivationNavigation.vue?vue&type=script&lang=js&"
import style0 from "./CultivationNavigation.vue?vue&type=style&index=0&id=5dc395fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc395fb",
  null
  
)

export default component.exports